// so we can easily identify and exclude e2e test users from extra services (e.g. analytics)
export const E2E_TEST_USER_SHARED_NAME = 'testing.framework';

export enum E2eTestUsernames {
  // biome-ignore lint/style/useLiteralEnumMembers: migrated from develop
  DISABLED_CUSTOM_TAXONOMY = `${E2E_TEST_USER_SHARED_NAME}.adaptive.disabled@reveliolabs.com`, // client group: Testing Framework - Adaptive Disabled
  // biome-ignore lint/style/useLiteralEnumMembers: migrated from develop
  SAVED_FILTERS_READ_ONLY = `${E2E_TEST_USER_SHARED_NAME}+saved_filters_read_only@reveliolabs.com`, // client group: Testing Framework
  // biome-ignore lint/style/useLiteralEnumMembers: migrated from develop
  STANDARD = `${E2E_TEST_USER_SHARED_NAME}@reveliolabs.com`, // client group: Testing Framework
  // biome-ignore lint/style/useLiteralEnumMembers: migrated from develop
  TRIAL = `${E2E_TEST_USER_SHARED_NAME}+trial_user@reveliolabs.com`, // client group: Testing Framework - Trial User
  // biome-ignore lint/style/useLiteralEnumMembers: migrated from develop
  TRIAL_EXPIRED = `${E2E_TEST_USER_SHARED_NAME}+trial_user_expired@reveliolabs.com`, // client group: revelio_self_signup
}
